import { Component, OnInit } from '@angular/core';
import { NavParams, App, Events, AlertController, LoadingController, NavController, ViewController } from 'ionic-angular';
import { UserEditPage } from '../userEdit/userEdit';
import { RechargePage } from '../recharge/recharge';
import { WithDrawalPage } from '../withDrawal/withDrawal';
import { PersonBankCardPage } from '../personBankCard/personBankCard';
import { PersonMsgPage } from '../personMsg/personMsg';
import { GameRecordSearchPage } from '../gameRecordSearch/gameRecordSearch';
import { BalanceChangeSearchPage } from '../balanceChangeSearch/balanceChangeSearch';
import { SysMsgListPage } from '../sysMsgList/sysMsgList';
import { UserService } from '../../services/user.services';
import { LoginPage } from '../login/login';
import { AppDialog } from '../../component/appDialog';
import { AppConfig } from '../../util/appConfig';
import { AgentPEPage } from '../agentPE/agentPE';
import { HomePage } from '../home/home';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../services/common.service';
import { TabsPage } from '../tabs/tabs';
import { LotteryService } from '../../services/lottery.services';
import { TranslateService } from 'ng2-translate';

@Component({
  templateUrl: 'user.html',
  selector: 'user-page',
})
export class UserPage implements OnInit {
  linkavatar: string = 'build/assets/images/home/avatar-2.webp';
  nickName: string;
  avatarUrl: string;
  loginname: string;
  phone: string;
  static helpUrl: string;
  isLogged = false;
  user: any;
  balance: any = '0';
  listOptionAccount: any = [
    {
      icon: 'build/assets/images/user/user.png',
      title: 'INFO_PERSONAL', // Placeholder for translation
      page: UserEditPage,
      badgeHas: false,
    },
    {
      icon: 'build/assets/images/user/messages-2.png',
      title: 'MESSAGES', // Placeholder for translation
      page: PersonMsgPage,
      badgeHas: true,
    },
    {
      icon: 'build/assets/images/user/clock.png',
      title: 'TRANSACTION_HISTORY', // Placeholder for translation
      page: GameRecordSearchPage,
      badgeHas: false,
    },
    {
      icon: 'build/assets/images/user/dollar-circle.png',
      title: 'BALANCE_CHANGE', // Placeholder for translation
      page: BalanceChangeSearchPage,
      badgeHas: false,
    },
    {
      icon: 'build/assets/images/user/notification-bing.png',
      title: 'NOTIFICATIONS', // Placeholder for translation
      page: SysMsgListPage,
      badgeHas: false,
    },
    {
      icon: 'build/assets/images/user/receive-square.png',
      title: 'VERSION', // Placeholder for translation
      des: AppConfig.Version,
      badgeHas: false,
    },
    {
      icon: 'build/assets/images/user/message-question.png',
      title: 'HELP', // Placeholder for translation
      badgeHas: false,
      url: UserPage.helpUrl,
    },
  ];
  public vnd: string = 'VNDK';
  public isAccountTest: boolean = true;
  public badgeNumber: number = 0;
  public selectedLanguage: string = 'vi';
  constructor(
    public _DomSanitizer: DomSanitizer,
    private app: App,
    public navParams: NavParams,
    public events: Events,
    private common: CommonService,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController,
    private userService: UserService,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    private lotteryService: LotteryService,
    public cs: CommonService,
    private translate: TranslateService
  ) {
    if (cs.userType > 1) {
      // is not account test
      this.isAccountTest = false;
    }

    const storedLanguage = localStorage.getItem('langcode');
    if (storedLanguage) {
        this.selectedLanguage = storedLanguage;
    } else {
        this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
    }
    

    if (navParams.data != '') {
      console.log('navParams.data', navParams.data);
      this.isLogged = true;
      this.nickName = navParams.data['nickname'];
      this.loginname = navParams.data['loginname'];
      this.user = navParams.data;
      this.linkavatar = navParams.data['avatarUrl'];

      events.subscribe('nickname:get', (userEventData) => {
        this.nickName = userEventData;
        this.user['nickname'] = userEventData;
      });
      events.subscribe('phone:get', (userEventData) => {
        this.user['phone'] = userEventData;
      });
      events.subscribe('verifiedphone:get', (userEventData) => {
        this.user['verifiedphone'] = userEventData;
      });

      this.badgeNumber = TabsPage.getCountUnReadMsg;
      events.subscribe('countUnReadMsg:get', (dataEvent) => {
        this.badgeNumber = dataEvent;
      });
    }

    this.vnd = LoginPage.vndTitle;
  }
  
  onLanguageChange(event) {
    this.common.languageChange(this.selectedLanguage);
  }

  ngOnInit() {
    // this.updateOptionAccountTitles(); // Update option account titles
  }

  // Method to update option account titles after language change
  updateOptionAccountTitles() {
    this.listOptionAccount = this.listOptionAccount.map(option => {
      option.title = this.translate.instant(option.title);
      return option;
    });
  }

  withDrawal() {
    if (!this.isLogged) {
      this.onLogin();
      return;
    }

    if (!this.isAccountTest) {
      this.translate.get('ACCOUNT_TEST_MESSAGE').subscribe((message) => {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: message,
        });
      });
    } else {
      this.app.getRootNav().push(WithDrawalPage);
    }
  }

  recharge() {
    if (!this.isLogged) {
      this.onLogin();
      return;
    }

    if (!this.isAccountTest) {
      this.translate.get('ACCOUNT_TEST_MESSAGE').subscribe((message) => {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: message,
        });
      });
    } else {
      this.app.getRootNav().push(RechargePage);
    }
  }

  personBankCardPage() {
    if (!this.isLogged) {
      this.onLogin();
      return;
    }

    if (!this.isAccountTest) {
      this.translate.get('ACCOUNT_TEST_MESSAGE').subscribe((message) => {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: message,
        });
      });
    } else {
      this.app.getRootNav().push(PersonBankCardPage);
    }
  }

  goPage(item: any) {
    if (!this.isLogged) {
      this.onLogin();
      return;
    }
    if (item.url !== null && item.url !== undefined) {
      window.open(item.url, '_blank');
    }
    if (item.page !== null && item.page !== undefined) {
      this.app.getRootNav().push(item.page, this.user);
    }
  }

  loginOutFn() {
    this.userService.loginOut(undefined, this).then((data) => {
      document.cookie = `JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      if (data['msg'] == '') {
        this.setTheme('theme-default');
        this.app.getRootNav().setRoot(LoginPage);
        this.cs.userType = 0;
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data['msg'],
        });
      }
    });
  }

  setTheme(theme: string) {
    const body = document.body;
    body.classList.remove('loto188');
    if (theme === 'loto188') {
      body.classList.add('loto188');
    } else {
      body.classList.add('theme-default');
    }
  }

  onLogin() {
    this.app.getRootNav().push(LoginPage);
  }

  ionViewWillEnter() {
    if (this.isLogged) {
      this.lotteryService.getBalance((data) => {
        this.balance = this.cs.numberWithCommas(data['balance']);
      });
    } else {
      this.app.getRootNav().push(LoginPage);
    }
  }

  ionViewWillLeave() {}
}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts